import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <p>&copy; 2026 San Juan Events LLC</p>
    </footer>
  );
}

export default Footer;